<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">پرداخت با اسنپ پی</h5>
        <div style="flex: 1"></div>
        <router-link :to="`/admin/shop/orders/${orderId}?print=1`" class="btn btn-secondary mx-3">
          <span style="color:white !important;">
            پرینت فاکتور
          </span>
        </router-link>
        <Back url="/admin/shop" />

      </div>
      <div class="card-body">
        <form @submit.prevent="requestProduct">

          <b-form-group label="کد انبار">
            <div class="d-flex col-md-6" style="gap: 0.5rem">
              <b-form-input v-model="storeId" readonly />
            </div>
          </b-form-group>
          <b-form-group label="مبلغ ارسال به اسنپ پی(تومان)">
            <div class="d-flex col-md-6" style="gap: 0.5rem">
              <b-form-input :value="snappayCashierAmount | priceinput" readonly />
            </div>
          </b-form-group>
          <b-form-group label="اسکن بارکد">
            <div class="d-flex col-md-6" style="gap: 0.5rem">
              <b-form-input autocomplete="off" autofocus ref="productSku" v-model="snappayBarcode"
                :disabled="disabledBarcode" @keypress.prevent.enter="requestProduct" type="text" />
            </div>
          </b-form-group>
        </form>
        <div class="d-flex flex-column justify-content-center align-items-center mt-5" v-if="transactionId">
          <button class="inquiry-btn" @click="inquiry" :disabled="disabled">
            استعلام خرید
          </button>

          <p v-if="returnedLabelStatus" class="mt-3">
            نتیجه استعلام :
            <span class="font-weight-bold mr-1">{{ returnedLabelStatus }}.</span>
            <span v-if="returnedStatus == 'SETTLE'" class="d-flex align-items-center mt-2">
              در این وضعیت میتونید سفارش رو <button class="btn btn-danger btn-sm mx-2" @click="cancel">کنسل</button>
              کنید.
            </span>
          </p>
          <button class="btn btn-info mt-5" v-if="isBuy" @click="verify" :disabled="disabled">
            تایید خرید
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import PlusSvg from "@@/core/components/svgs/PlusSvg";
import DashSvg from "@@/core/components/svgs/DashSvg";
import Back from "@@/core/components/shared/Back/Back";

export default {
  name: "SendData",
  components: {
    DashSvg,
    PlusSvg,
    BFormGroup,
    BFormInput,
    BButton,
    Back,
  },
  data() {
    return {
      disabled: false,
      disabledBarcode: false,
      snappayBarcode: "",
      orderId: this.$route.params.id,
      snappayCashierAmount: this.$route.query.snappay_amount,
      adminId: this.$route.query.admin_id,
      storeId: this.$route.query.store_id,
      providerId: null,
      transactionId: null,
      returnedStatus: "",
      returnedLabelStatus: "",
      isBuy: false,
      statuses: {
        PENDING_FOR_CONFIRMATION: "خرید در انتظار تایید مشتری است",
        PAID: "خرید انجام شده اما نهایی نشده است",
        SETTLE: "خرید تسویه حساب شده است",
        CANCEL: "خرید انصراف داده شده است",
        INIT: "تراکنش خرید ارسال شده است",
        COMPLETED: "خرید نهایی شده است",
        PENDING: "خرید در انتظار است",
      }
    };
  },
  methods: {
    async requestProduct() {
      try {
        this.disabledBarcode = true;
        this.transactionId = null;
        console.log(this.snappayBarcode, 'this.snappayBarcodethis.snappayBarcode');

        const response = await this.$axios.post("admin/snapp-pay-cashier-payment",
          {
            barcode: this.snappayBarcode,
            terminalId: this.adminId,
            amount: this.snappayCashierAmount,
            order_id: this.orderId,
            branch_code: this.storeId,
          }
        );
        // this.providerId = response.data;
        this.transactionId = response.data.transactionId;
        this.$root.notify("درخواست پرداخت با موفقیت ارسال شد.", "success");
        this.snappayBarcode = "";
      } catch (e) {
        this.$root.notify(e);
        this.disabledBarcode = false;
      } finally {
        this.$nextTick(() => {
          this.$refs.productSku.focus();
        });
      }
    },
    async inquiry() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/snapp-pay-cashier-inquiry",
          {
            params: {
              transactionId: this.transactionId,
            }
          }
        );
        this.returnedStatus = response.data.raw.response.status;
        this.returnedLabelStatus = this.statuses[this.returnedStatus];
        this.isBuy = true;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    async reverse() {
      try {
        this.disabled = true;
        const response = await this.$axios.post("admin/snapp-pay-cashier-reverse",
          {
            provider_id: this.providerId,
          }
        );
        this.$root.notify("سفارش با موفقیت کنسل شد.", "success");

      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    async cancel() {
      try {
        this.disabled = true;
        const response = await this.$axios.post("admin/snapp-pay-cashier-cancel",
          {
            transactionId: this.transactionId,
            // provider_id: this.providerId,
          }
        );
        this.$root.notify("خرید کنسل شد.", "success");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    async cancelOrder() {
      try {
        this.disabled = true;
        const response = await this.$axios.post(`admin/mini-orders/${this.id}/cancel`);
        console.log(response.data, 'response');
        this.$root.notify("سفارش با موفقیت کنسل شد.", "success");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    async verify() {
      try {
        this.disabled = true;
        const response = await this.$axios.post("admin/snapp-pay-cashier-verify",
          {
            barcode: this.snappayBarcode,
            // barcode: "w1040",
            transactionId: this.transactionId,
            amount: this.snappayCashierAmount,
          }
        );
        this.$root.notify("خرید نهایی شد.", "success");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
  created() {

  },
};
</script>
<style src="@@/core/pages/physicalShop/snappay/snappayStyle.css"></style>